import React from 'react';
import { FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import './Branches.css';

function Branches() {
  const branches = [
    {
      id: 1,
      name: 'WHOLESALE & HEAD OFFICE',
      location: 'NICO CENTRE BUILDING, SHOP #8',
      address: 'GAME CAR PARK, OLD TOWN LILONGWE',
      contact: ['+265 1 750 616']
    },
    {
      id: 2,
      name: 'RETAIL LILONGWE',
      location: 'NICO CENTRE BUILDING',
      address: 'GAME CAR PARK, OLD TOWN LILONGWE',
      contact: ['+265 1 750 616']
    },
    {
      id: 3,
      name: 'BLANTYRE BRANCH',
      location: 'ANADKAT HOUSE',
      address: 'OPPOSITE CHIBISA HOUSE, ALONG SIR GLYN JONES ROAD',
      contact: ['+265 01 820 001', '+265 0997 603 953']
    },
    {
      id: 4,
      name: 'LIMBE BRANCH',
      location: 'ILLOVOVO ROUNDABOUT',
      address: 'OPPOSITE PUMA FILLING STATION',
      contact: ['+265 0999 266 883']
    },
    {
      id: 5,
      name: 'MZUZU BRANCH',
      location: 'OPPOSITE CONTINENTAL BAKERY',
      address: '',
      contact: ['+265 991 580 240', '+265 1312 993']
    },
    {
      id: 6,
      name: 'SALIMA BRANCH',
      location: 'OFF KAMUZU ROAD',
      address: '',
      contact: ['+265 994 339 731']
    },
    {
      id: 7,
      name: 'MANGOCHI BRANCH',
      location: 'MAIN ROUNDABOUT, OFF CHILIPA ROAD',
      address: 'ADJACENT TO AHAD SHOP',
      contact: ['+265 994 439 536', '+265 882 693 236']
    }
  ];

  return (
    <div className="branches">
      <div className="branches-container">
        <div className="branches-header">
          <h2>Our Branches</h2>
          <p className="branches-intro">
            With seven locations across Malawi, we're here to serve you. 
            Visit any of our convenient locations for quality pharmaceutical products and professional healthcare advice.
          </p>
        </div>

        <div className="branches-grid">
          {branches.map((branch) => (
            <div key={branch.id} className="branch-card">
              <div className="branch-icon"><FaMapMarkerAlt /></div>
              <h3>{branch.name}</h3>
              <div className="branch-details">
                <p className="branch-location">{branch.location}</p>
                {branch.address && <p className="branch-address">{branch.address}</p>}
              </div>
              {branch.contact && (
                <div className="branch-contacts">
                  {branch.contact.map((phone, index) => (
                    <a key={index} href={`tel:${phone}`} className="branch-phone">
                      <FaPhone /> {phone}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Branches;
